import { observer } from 'mobx-react'
import React from 'react'
import { TermsAndConditions } from '../components/TermsAndConditions/TermsAndConditions'

export const TermsAndConditionsPage = observer(() => {
  return <TermsAndConditions />
})
